export function setTableColumnsWidth (id, val) {
  window.localStorage.setItem(`${id}-columns-width`, val)
}

export function getTableColumnsWidth (id) {
  return window.localStorage.getItem(`${id}-columns-width`)
}

export function setTableRowsHeight (id, val) {
  window.localStorage.setItem(`${id}-rows-height`, val)
}

export function getTableRowsHeight (id) {
  return window.localStorage.getItem(`${id}-rows-height`)
}

export function getCollapseColumns (id) {
  return window.localStorage.getItem(`${id}-collapse-columns`)
}

export function setCollapseColumns (id, val) {
  window.localStorage.setItem(`${id}-collapse-columns`, val)
}
